module.exports = __webpack_public_path__ + "img/icon_view_1.b60070e7.svg";